<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb :crumbs="[$t('menu.rents'), $t('text.create')]"></breadcrumb>
      <div class="container">
        <el-form ref="rentForm" :model="rent" size="small" label-width="90px">
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>{{ $t("text.baseInfo") }}</legend>
              <el-row>
                <el-col :span="7">
                  <el-form-item
                    :label="$t('rent.serialNo')"
                    :prop="'serialNo'"
                    :rules="[
                      {
                        required: true,
                        validator: validateSerialNo,
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      v-model.trim="rent.serialNo"
                      :placeholder="$t('prompt.alphabetNumberLine')"
                      clearable
                      @blur="blurRentSerialNo()"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="$t('menu.shops')"
                    :prop="'shopId'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('menu.shops')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      size="small"
                      v-model="rent.shopId"
                      clearable
                      filterable
                      :disabled="Permit.createOrderFixShopDF()"
                    >
                      <el-option
                        v-for="shop in shops"
                        :key="shop.id"
                        :label="shop.name"
                        :value="shop.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('rent.rentAt')"
                    :prop="'_rentAt'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('rent.rentAt')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-date-picker
                      size="small"
                      v-model="rent._rentAt"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="-"
                      :start-placeholder="
                        $t('rules.startAt', [$t('rent.rentAt')])
                      "
                      :end-placeholder="$t('rules.endAt', [$t('rent.rentAt')])"
                      :picker-options="pickerOptions"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset class="mgb15">
              <legend>
                {{ $t("customer.customerInfo") }}
                <span class="blue" @click="showAddressInfo">{{
                  $t("customer.addressInfo")
                }}</span>
              </legend>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('customer.phoneSerialNo')"
                    :prop="'customerPhone'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [
                          $t('customer.phoneSerialNo'),
                        ]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-autocomplete
                      size="small"
                      v-model.trim="rent.customerPhone"
                      :fetch-suggestions="queryCustomerPhone"
                      :trigger-on-focus="false"
                      style="width: 100%"
                      @select="handleSelectCustomerPhone"
                    >
                      <template slot-scope="{ item }">
                        <div class="name">{{ item.phone }}</div>
                        <span class="addr"
                          >{{ item.name }}-{{ item.company }}</span
                        >
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('bargain.customerName')"
                    :prop="'customerName'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [
                          $t('bargain.customerName'),
                        ]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      v-model.trim="rent.customerName"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('customer.source')">
                    <el-autocomplete
                      size="small"
                      v-model.trim="rent.customerSource"
                      :fetch-suggestions="querySearchSources"
                      style="width: 100%"
                      @select="handleSelectSources"
                    ></el-autocomplete>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-if="showAddressInfoDF">
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('tenant.country')">{{
                      $t("countries." + rent.customerCountry)
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('tenant.province')"
                      :prop="'province'"
                    >
                      <el-input
                        size="small"
                        v-model.trim="rent.customerProvince"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('tenant.city')" :prop="'city'">
                      <el-input
                        size="small"
                        v-model.trim="rent.customerCity"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('tenant.address')"
                      :prop="'address'"
                    >
                      <el-input
                        size="small"
                        v-model.trim="rent.customerAddress"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('customer.zipcode')"
                      :prop="'zipcode'"
                    >
                      <el-input
                        size="small"
                        v-model.trim="rent.customerZipcode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="customerBalance != null" :span="8">
                    <el-form-item
                      :label="$t('customer.balance')"
                      :prop="'balance'"
                      >{{ customerBalance | currency }}</el-form-item
                    >
                  </el-col>
                </el-row>
              </div>
            </fieldset>
            <fieldset class="mgb15">
              <legend>{{ $t("menu.products") }}</legend>
              <div
                class="flex flex-between mgb10"
                v-for="(rentItem, index) in rent.rentItems"
                :key="index"
              >
                <div class="mgr10">
                  <thumbnail :images="rentItem.images" />
                </div>
                <div class="flex-grow">
                  <el-row :gutter="20">
                    <el-col :span="19">
                      <el-row :gutter="20" class="mgb10">
                        <el-col :span="6">
                          <el-input
                            size="small"
                            v-model.trim="rentItem.serialNo"
                            :placeholder="
                              $t('rules.mustFillSimple', [
                                $t('rentItem.serialNo'),
                              ])
                            "
                            @blur="blurRentItemSerialNo(index)"
                          ></el-input>
                        </el-col>
                        <el-col :span="6">
                          <el-autocomplete
                            size="small"
                            v-model.trim="rentItem.productNo"
                            :fetch-suggestions="querySearchProductNo"
                            :data-index="index"
                            :trigger-on-focus="false"
                            style="width: 100%"
                            :placeholder="
                              $t('rules.mustFillSimple', [
                                $t('product.productNo'),
                              ])
                            "
                            @focus="getFoucs(index)"
                            @select="handleSelectProductNo(index)"
                          ></el-autocomplete>
                        </el-col>
                        <el-col :span="6">
                          <el-autocomplete
                            size="small"
                            v-model.trim="rentItem.color"
                            :fetch-suggestions="querySearchColor"
                            :placeholder="$t('product.color')"
                            style="width: 100%"
                            @select="handleSelectColor(index)"
                          ></el-autocomplete>
                        </el-col>
                        <el-col :span="6">
                          <el-autocomplete
                            size="small"
                            v-model="rentItem.size"
                            :fetch-suggestions="querySearchSize"
                            :placeholder="$t('product.size')"
                            style="width: 100%"
                            @select="handleSelectSize(index)"
                          ></el-autocomplete>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="6">
                          <el-input
                            size="small"
                            v-model.trim="rentItem.quantity"
                            :placeholder="
                              $t('rules.mustFillSimple', [$t('text.quantity')])
                            "
                            @blur="computerAmount"
                          ></el-input>
                        </el-col>
                        <el-col :span="6">
                          <el-input
                            size="small"
                            v-model.trim="rentItem.price"
                            :placeholder="
                              $t('rules.mustFillSimple', [$t('rentItem.price')])
                            "
                            @blur="computerAmount"
                          ></el-input>
                        </el-col>
                        <el-col :span="6">
                          {{ $t("order.subtotal") }}:
                          {{
                            (rentItem.price * rentItem.quantity) | currency
                          }}</el-col
                        >
                      </el-row>
                    </el-col>
                    <el-col :span="5">
                      <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="备注"
                        v-model="rentItem.remark"
                      ></el-input>
                    </el-col>
                  </el-row>
                  <div v-if="rentItem.images != null">
                    <dropzone v-model="rentItem.images" multiple />
                  </div>
                </div>
                <div class="remove-order">
                  <el-button
                    type="text"
                    size="small"
                    @click="remove(index)"
                    v-if="index != 0"
                    >{{ $t("text.remove") }}</el-button
                  >
                </div>
              </div>
              <div class="center">
                <el-button
                  v-if="rent.rentItems.length < 10"
                  type="info"
                  @click="addMore"
                  plain
                  round
                >
                  {{ $t("action.addProduct") }}
                </el-button>
                <span v-else class="orange">
                  {{ $t("prompt.addMorePrompt") }}
                </span>
              </div>
            </fieldset>
            <fieldset class="mgb15">
              <legend>{{ $t("bargain.paymentInfo") }}</legend>
              <el-row>
                <el-col :span="16">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('payment.total')"
                        :prop="'_paymentTotal'"
                        :rules="[
                          {
                            required: true,
                            message: $t('rules.required', [
                              $t('payment.total'),
                            ]),
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-input
                          v-model="rent._paymentTotal"
                          @blur="selectPayMethod"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('payment.payMethod')"
                        :prop="'_paymentPayMethodId'"
                        :rules="[
                          {
                            required: true,
                            message: $t('rules.required', [
                              $t('payment.payMethod'),
                            ]),
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-select
                          v-model="rent._paymentPayMethodId"
                          @change="selectPayMethod"
                        >
                          <el-option
                            v-for="payMethod in payMethods"
                            :key="payMethod.id"
                            :label="payMethod.name"
                            :value="payMethod.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('payment.paidAt')"
                        :prop="'_paymentPaidAt'"
                        :rules="[
                          {
                            required: true,
                            message: $t('rules.required', [
                              $t('payment.paidAt'),
                            ]),
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-date-picker
                          size="small"
                          v-model="rent._paymentPaidAt"
                          type="date"
                          style="width: 100%"
                          :picker-options="pickerOptionsFiveDays"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('payment.explain')"
                        :prop="'_paymentExplain'"
                      >
                        <el-input v-model="rent._paymentExplain"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :span="6">
                  <el-form-item
                    :label="$t('payment.voucher')"
                    :prop="'_paymentVoucher'"
                  >
                    <upload-single-picture v-model="rent._paymentVoucher" />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset class="mgb15">
              <legend>{{ $t("text.remark") }}</legend>
              <el-input
                v-model="rent.remark"
                type="textarea"
                :rows="2"
              ></el-input>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import UploadSinglePicture from "@/components/UploadSinglePicture";
import Dropzone from "@/components/Dropzone";
import Shop from "@/api/shop.js";
import Color from "@/api/color.js";
import Size from "@/api/size.js";
import PayMethod from "@/api/payMethod.js";
import Rent from "@/api/rent.js";
import Customer from "@/api/customer.js";
import RentItem from "@/api/rentItem.js";

import Product from "@/api/product.js";
import Inventory from "@/api/inventory.js";
import User from "@/api/user.js";

function bulid() {
  return {
    serialNo: null,
    productNo: null,
    color: null,
    size: null,
    quantity: null,
    unit: null,
    price: null,
    images: null,
    remark: null,
    _productNoColors: [],
    _productNoSizes: [],
  };
}
export default {
  mixins: [page],
  components: { BackButton, UploadSinglePicture, Dropzone },
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value.trim() === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("bargain.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumberLine(value)) {
        callback(new Error(this.$t("prompt.regexAlphabetNumberLine")));
        return;
      }
      Rent.findBySerialNo({ serialNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("rent.serialNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      validateSerialNo: validateSerialNo,
      Util: Util,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pickerOptionsFiveDays: {
        disabledDate(time) {
          const curDate = new Date().getTime();
          const day = 5 * 24 * 3600 * 1000;
          const threeMonths = curDate - day;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        },
      },
      shops: [],
      colors: [],
      sizes: [],
      payMethods: [],
      products: [],
      rent: {
        serialNo: Util.serialNo(),
        shopId: null,
        shopName: null,
        customerId: null,
        customerName: null,
        customerCountry: "CN",
        customerProvince: null,
        customerCity: null,
        customerZipcode: null,
        customerAddress: null,
        customerPhone: null,
        customerSource: null,
        rentItems: [bulid(), bulid(), bulid()],
        payments: [],
        startAt: null,
        endAt: null,
        remark: null,
        _rentAt: null,
        _paymentTotal: null,
        _paymetPayMethodId: null,
        _paymentExplain: null,
        _paymentVoucher: null,
        _paymentPaidAt: new Date(),
      },
      customerBalance: null,
      amount: 0,
      showAddressInfoDF: false,
      customers: [],
      payMethods: [],
      saveDoing: false,
      currentIndex: null,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.blurRentSerialNo();
    axios
      .all([
        Shop.findByTenantId(),
        Color.findByTenantId(),
        Size.findByTenantId(),
        PayMethod.findByTypes({ types: PayMethod.saleTypes }),
      ])
      .then(
        axios.spread(function (shops, colors, sizes, payMethods) {
          if (shops.status === 200) {
            self.shops = shops.data;
            self.rent.shopId = self.Permit.currentUser().shopId;
          } else {
            self.sysError();
          }
          if (colors.status === 200) {
            self.colors = colors.data;
          } else {
            self.sysError();
          }
          if (sizes.status === 200) {
            self.sizes = sizes.data;
          } else {
            self.sysError();
          }
          if (payMethods.status === 200) {
            self.payMethods = payMethods.data;
            // self.payMethods.push({ id: -1, name: "账户余额" });
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    blurRentSerialNo() {
      const self = this;
      self.rent.serialNo = self.rent.serialNo.trim();
      if (self.rent.rentItems.length === 1) {
        self.rent.rentItems[0].serialNo = self.rent.serialNo;
      } else {
        for (let i = 0; i < self.rent.rentItems.length; i++) {
          self.rent.rentItems[i].serialNo = self.rent.serialNo + "-" + (i + 1);
        }
      }
    },
    showAddressInfo() {
      this.showAddressInfoDF = !this.showAddressInfoDF;
    },

    queryCustomerPhone(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      self.rent.customerId = null;
      self.rent.customerName = null;
      self.rent.customerCountry = null;
      self.rent.customerProvince = null;
      self.rent.customerCity = null;
      self.rent.customerAddress = null;
      self.rent.customerSource = null;
      self.rent.customerZipcode = null;
      self.customerBalance = null;
      self.computePayMethods();
      Customer.vagueFind({ keyword: queryString }).then(function (res) {
        const ps = res.data;
        ps.forEach((p) => (p.value = p.phone));
        self.customers = ps;
        cb(self.customers);
      });
    },
    handleSelectCustomerPhone() {
      const self = this;
      const item = self.customers.find(
        (p) => p.phone === self.rent.customerPhone
      );
      self.rent.customerId = item.id;
      self.rent.customerName = item.name;
      self.rent.customerPhone = item.phone;
      self.rent.customerCountry = item.country;
      self.rent.customerProvince = item.province;
      self.rent.customerCity = item.city;
      self.rent.customerAddress = item.address;
      self.rent.customerSource = item.source;
      self.rent.customerZipcode = item.zipcode;
      self.customerBalance = item.balance;
      self.computePayMethods();
    },
    computePayMethods() {
      const self = this;
      if (self.customerBalance != null) {
        self.payMethods.push({
          id: -1,
          name: "账户余额(¥" + self.customerBalance + ")",
        });
      } else {
        self.payMethods = self.payMethods.filter((p) => p.id != -1);
      }
    },
    // 来源
    querySearchSources(queryString, cb) {
      Customer.sources().then(function (res) {
        const sources = res.data.map((item) => {
          return { value: item };
        });
        cb(sources);
      });
    },
    handleSelectSources(item) {
      this.rent.customerSource = item.value;
    },

    //===

    addMore() {
      this.rent.rentItems.push(bulid());
      this.generateOrderSerialNo();
    },

    remove(index) {
      this.rent.rentItems.splice(index, 1);
      this.generateOrderSerialNo();
    },
    generateOrderSerialNo() {
      this.blurRentSerialNo();
      this.computerAmount();
    },
    computerAmount() {
      const self = this;
      let amount = 0;
      if (this.rent.rentItems.length !== 0) {
        for (const rentItem of this.rent.rentItems) {
          amount = amount + rentItem.price * rentItem.quantity;
        }
      }
      self.amount = amount;
      self.rent._paymentTotal = amount;
    },

    blurRentItemSerialNo(index) {
      const self = this;
      if (
        this.rent.rentItems[index].serialNo === null ||
        this.rent.rentItems[index].serialNo === ""
      ) {
        self.$message({
          message: this.$t("rules.required", [this.$t("rentItem.rentItem")]),
          type: "warning",
        });
        return;
      }
      // 前台本地过滤
      const iis = self.rent.rentItems.filter(function (ii) {
        return ii.serialNo === self.rent.rentItems[index].serialNo;
      });
      if (iis.length > 1) {
        self.$message({
          message: this.$t("rules.exist", [this.$t("rentItem.serialNo")]),
          type: "warning",
        });
        self.rent.rentItems[index].serialNo = null;
        return;
      }
      RentItem.findBySerialNo({
        serialNo: self.rent.rentItems[index].serialNo,
      }).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("rules.exist", [self.$t("rentItem.serialNo")]),
            type: "warning",
          });
          self.rent.rentItems[index].serialNo = null;
        }
      });
    },
    getFoucs(index) {
      const self = this;
      self.currentIndex = index;
    },
    querySearchProductNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Product.vagueFindByProductNo({ productNo: queryString }).then(function (
        res
      ) {
        const ps = res.data;
        ps.forEach((p) => (p.value = p.productNo));
        self.products = ps;
        cb(self.products);
      });
    },
    handleSelectProductNo(idx) {
      const self = this;
      const item = self.products.find(
        (p) => p.productNo === self.rent.rentItems[idx].productNo
      );
      self.rent.rentItems[idx].productNo = item.productNo;
      self.rent.rentItems[idx].color = null;
      self.rent.rentItems[idx].size = null;
      self.rent.rentItems[idx].images = item.images;
      self.rent.rentItems[idx].price = null;
      self.rent.rentItems[idx].unit = item.unit;
      self.rent.rentItems[idx]._productNoColors = item.colors;
      self.rent.rentItems[idx]._productNoSizes = item.sizes;
    },
    // 颜色
    querySearchColor(queryString, cb) {
      const self = this;
      const colors =
        self.rent.rentItems[self.currentIndex]._productNoColors.length !== 0
          ? self.rent.rentItems[self.currentIndex]._productNoColors.map(
              (pc) => {
                return { value: pc };
              }
            )
          : self.colors.map((c) => {
              return { value: c.name };
            });

      if (queryString == null) {
        cb(colors);
      } else {
        cb(colors.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectColor(idx) {
      this.rent.rentItems[idx].color = this.rent.rentItems[idx].color;
    },
    // 规格
    querySearchSize(queryString, cb) {
      const self = this;
      const sizes =
        self.rent.rentItems[self.currentIndex]._productNoSizes.length !== 0
          ? self.rent.rentItems[self.currentIndex]._productNoSizes.map((pc) => {
              return { value: pc };
            })
          : this.sizes.map((c) => {
              return { value: c.name };
            });

      if (queryString == null) {
        cb(sizes);
      } else {
        cb(sizes.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectSize(idx) {
      const self = this;
      self.rent.rentItems[idx].size = this.rent.rentItems[idx].size;
    },

    selectPayMethod() {
      const self = this;
      if (
        self.rent._paymentPayMethodId != null &&
        self.rent._paymentPayMethodId < 0
      ) {
        if (self.rent._paymentTotal > self.customerBalance) {
          self.$message({
            message: this.$t("prompt.customerBalanceNotEnougth"),
            type: "warning",
          });
          self.rent._paymentPayMethodId = null;
        }
      }
    },
    saveSubmit() {
      const self = this;
      this.$refs.rentForm.validate((valid) => {
        if (valid) {
          const validRentItems = this.rent.rentItems.filter(
            (o) =>
              o.serialNo !== "" &&
              o.serialNo !== null &&
              o.productNo !== "" &&
              o.productNo !== null &&
              o.quantity !== null &&
              o.quantity !== ""
          );
          if (validRentItems.length === 0) {
            self.$message.error(this.$t("prompt.atLeastOneValidDataFillIn"));
            return;
          }
          User.findByPhone({ phone: self.rent.customerPhone }).then(function (
            res
          ) {
            if (
              res.data.code === 200 &&
              res.data.entity.tenantId === self.Permit.currentTenant().id
            ) {
              self.$message.error(self.$t("prompt.notAddOneself"));
            } else {
              for (const o of validRentItems) {
                if (!Util.regexQuantity(o.price)) {
                  self.$message({
                    message: self.$t("rules.regex", [self.$t("order.price")]),
                    type: "warning",
                  });
                  return;
                }
                if (!Util.regexQuantity(o.quantity) || o.quantity === 0) {
                  self.$message({
                    message: self.$t("rules.regex", [self.$t("text.quantity")]),
                    type: "warning",
                  });
                  return;
                }
              }
              if (!Util.regexQuantity(self.rent._paymentTotal)) {
                self.$message({
                  message: self.$t("rules.regex", [self.$t("payment.total")]),
                  type: "warning",
                });
                return;
              }
              self.rent.rentItems = validRentItems;

              //
              var newPaymentObj = {
                total: self.rent._paymentTotal,
                payMethodId: self.rent._paymentPayMethodId,
                payMethodName: self.payMethods.find(
                  (p) => p.id === self.rent._paymentPayMethodId
                ).name,
                paidAt: Util.formatDate(self.rent._paymentPaidAt),
                explain: self.rent._paymentExplain,
                currency: "CNY",
                voucher: self.rent._paymentVoucher,
              };
              self.rent.payments = [newPaymentObj];
              //
              self.rent.startAt = Util.formatDate(self.rent._rentAt[0]);
              self.rent.endAt = Util.formatDate(self.rent._rentAt[1]);
              self.rent.shopName = self.shops.find(
                (s) => s.id === self.rent.shopId
              ).name;
              if (self.rent.rentItems.length === 1) {
                self.rent.rentItems[0].serialNo = self.rent.serialNo;
              }
              self.saveDoing = true;
              Rent.create(self.rent).then(function (res) {
                self.saveDoing = false;
                if (res.status === 200) {
                  self.$message({
                    message: self.$t("prompt.addSuccess"),
                    type: "success",
                  });
                  self.$router.push({ name: "rents" });
                } else {
                  self.sysError();
                }
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>


<style scoped>
.remove-order {
  width: 50px;
  text-align: center;
  line-height: 80px;
}
</style>